<template>
  <v-container fluid>
    <leave-report-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      LeaveReportContainerView: () => import('@/components/hris/reports/leaves/LeaveReports'),
    },
  }
</script>
